import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import LogoZKcandy from '../Assets/logo-zkcandy-white.svg';
import LogoSmall from '../Assets/logo-zkcandy-small-white.webp';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';

const Header = () => {
  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Tokenomics', path: '/tokenomics' },
    { name: 'Grants/Funding', path: '/grants-funding' },
    { name: 'About', path: '/about' },
    { name: 'Contact', path: '/contact' },
    { name: 'Docs', path: 'https://docs.zkcandyapi.com/' },
  ];

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(prevState => !prevState);
  };

  return (
    <header className="header">
      <div className="container mx-auto px-4">
        <nav className="navigation lg:flex justify-between items-center py-6 font-russo text-[1rem] hidden">
          <ul className="flex space-x-7 uppercase">
            {navLinks.slice(0, -3).map((link, index) => (
              <li key={index}>
                {link.path.includes('http') ? (
                  <a href={link.path} target="_blank" rel="noopener noreferrer">{link.name}</a>
                ) : (
                  <Link to={link.path}>{link.name}</Link>
                )}
              </li>
            ))}
          </ul>

          <Link to="/" className="logo absolute left-1/2 transform -translate-x-1/2">
            <img className="w-[80px]" src={LogoSmall} alt="ZKcandy" />
          </Link>
          <ul className="flex space-x-10 uppercase">
            {navLinks.slice(-3).map((link, index) => (
              <li key={index}>
                {link.path.includes('http') ? (
                  <a href={link.path} target="_blank" rel="noopener noreferrer">{link.name}</a>
                ) : (
                  <Link to={link.path}>{link.name}</Link>
                )}
              </li>
            ))}
          </ul>
        </nav>

        <nav className={`mobile-nav p-3 lg:hidden ${isMenuOpen ? 'show' : ''}`}>
          <div className="flex justify-between">

            <Link to="/" className="logo">
              <img className="w-[110px]" src={LogoZKcandy} alt="ZKcandy" />
            </Link>

            <Bars3Icon className="size-6" onClick={toggleMenu} />
          </div>

          <ul className="absolute w-full h-screen bg-[#000000b3] top-[0px] backdrop-blur-md justify-center items-center flex flex-col space-y-8 uppercase font-medium font-russo text-[1.2rem]">
            <XMarkIcon className="size-6 absolute top-[1rem] right-[1rem]" onClick={toggleMenu} />
            {navLinks.map((link, index) => (
              <li key={index}>
                {link.path.includes('http') ? (
                  <a href={link.path} onClick={toggleMenu} target="_blank" rel="noopener noreferrer">{link.name}</a>
                ) : (
                  <Link  onClick={toggleMenu} to={link.path}>{link.name}</Link>
                )}
              </li>
            ))}
          </ul>

        </nav>
      </div>
    </header>
  );
};

export default Header;